import styled from '@emotion/styled'

export const EaidValidationContainer = styled.div`
  display: flex;

  & .reset-button:hover {
    cursor: pointer;
  }
`
